// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vlahnaqxebvncnzpgwtg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZsYWhuYXF4ZWJ2bmNuenBnd3RnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI5MTA1NzAsImV4cCI6MjA1ODQ4NjU3MH0.NVtulBgNytSngdJk47xfSSnesJEMKPlN_Y7YOVKSWZc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);